import { LoadableAfterPaint } from '@confluence/loadable';

export const AnalyticsByLine = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsAnalyticsByLine" */ '../src/components/AnalyticsByLine'
			)
		).AnalyticsByLine,
});
